import React, { useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { useForm, Controller } from 'react-hook-form'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../../Core/NewFillButton'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import { MenuItem } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { MotocyclesApi } from '../../../api/motorcycles.api'
import { GlobalTextField } from '../../Core/Input/ControlledTextField'

export const AddMotorcyclesPopup = ({ open, title, body, onConfirm, onCancel, ...props }) => {
  const { register, errors, getValues, setValue, triggerValidation, control } = useForm()
  const [selectGroupValue, setSelectGroupValue] = React.useState('Base Mile Group')
  const handleClose = () => {
    onCancel && onCancel()
  }

  const [options, setOptions] = React.useState([])

  const Confirm = async () => {
    let valid = await triggerValidation()
    if (!valid) return
    //handleClose()
    onConfirm && onConfirm(getValues())
  }

  const yearChange = async e => {
    let o = []
    if (e.target.value && e.target.value.length === 4) {
      const res = await MotocyclesApi.getMakes(e.target.value)
      o = res.parsedData.motorcycle_makes.filter(m => m != null)
    }
    setOptions(o)
  }

  useEffect(() => {
    const fetchMakes = async () => {
      const res = await MotocyclesApi.getMakes()
      if (!res.ok) return
      const makers = res.parsedData.motorcycle_makes.filter(m => m != null)
      setOptions(makers)
    }
    fetchMakes()
  }, [])

  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleClose}
      maxWidth={'md'}
      shouldHaveHeight
      circleHeader={
        <ElevatedCircle>
          {' '}
          <AlternateEmailIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={title}
    >
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">{title}</div>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className="textcenter margin-bottom-basic">
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                inputRef={register({ required: true })}
                error={!!errors.year}
                helperText={!!errors.year ?? 'Year is required'}
                autoComplete="year"
                type="number"
                onInput={e => (e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4))}
                label="Year"
                fullWidth
                variant="outlined"
                autoFocus
                name="year"
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="textcenter margin-bottom-basic">
              {/* <Autocomplete
            type="text"
            fullWidth
            variant="outlined"
            freeSolo={true}
            options={options}
            getOptionLabel={(option) => option}
            onChange={(c) =>
              setValue("make", c.target.innerHTML.toLocaleUpperCase())
            }
            onInput={(c) =>
              setValue("make", c.target.value.toLocaleUpperCase())
            }
            renderInput={(params) => (
              <Controller
              rules={{ required: true }}
              control={control}
              name="make"
              error={!!errors.make}
              helperText={!!errors.make && "Make is required"}
              as={
                <TextField
                {...params}
                variant="outlined"
                InputLabelProps={{className : 'avenir-book'}}
                inputProps={{
                  ...params.inputProps,
                  style: { textTransform: "uppercase" },
                }}
                label="Make"
                />
              }
              />
              )}
              /> */}
              <Controller
                rules={{ required: true, validate: field => field && field != 'none' }}
                control={control}
                name="make"
                error={!!errors.make}
                defaultValue={'none'}
                helperText={!!errors.make && 'Make is required'}
                as={
                  <TextField InputLabelProps={{ className: 'avenir-book' }} placeholder="Make" fullWidth select variant="outlined">
                    <MenuItem className="avenir-book" disabled value={'none'}>
                      Make
                    </MenuItem>
                    {options.map(make => (
                      <MenuItem className="avenir-book" value={make} key={make}>
                        {make}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </div>
          </Grid>
        </Grid>
        <Grid container></Grid>
        <div className="margin-top-basic textcenter">
          <GlobalTextField
            inputRef={register({ required: true })}
            errors={errors}
            helperText={!!errors.model && 'Model is required'}
            autoComplete="model"
            onInput={e => setValue('model', e.target.value.toLocaleUpperCase())}
            type="text"
            label="Model"
            inputProps={{ style: { textTransform: 'uppercase' } }}
            fullWidth
            autoFocus
            name="model"
          />
        </div>
        <div className="margin-top-basic textcenter">
          <GlobalTextField
            inputRef={register({ required: true })}
            errors={errors}
            helperText={!!errors.symbol && 'Symbol is required'}
            autoComplete="symbol"
            type="number"
            label="Symbol"
            fullWidth
            autoFocus
            name="symbol"
          />
        </div>

        <div className="margin-top-basic textcenter">
          <GlobalTextField
            errors={errors}
            inputRef={register({ required: false })}
            autoComßplete="pogressive symbol"
            label="Progressive Symbol"
            fullWidth
            autoFocus
            name="progressiveSymbol"
          />
        </div>

        <div className="margin-top-basic textcenter">
          <GlobalTextField
            inputRef={register({ required: true })}
            errors={errors}
            helperText={!!errors.engineCC && 'Engine CC  is required'}
            autoComplete="engine cc"
            type="number"
            label="Engine cc"
            fullWidth
            autoFocus
            name="engineCC"
          />
        </div>

        <div className="margin-top-basic textcenter">
          <GlobalTextField
            inputRef={register({ required: true })}
            errors={errors}
            helperText={!!errors.value && 'Value is required'}
            autoComplete="value"
            type="number"
            label="Value"
            fullWidth
            autoFocus
            name="value"
          />
        </div>

        <div className="margin-top-basic textcenter margin-bottom-basic">
          <Controller
            rules={{ validate: field => field && field != 'none' }}
            name="baseMilesGroup"
            defaultValue={'none'}
            control={control}
            error={!!errors.baseMilesGroup}
            helperText={!!errors.baseMilesGroup && 'Base Miles Group is required'}
            as={
              <TextField InputLabelProps={{ className: 'avenir-book' }} fullWidth select variant="outlined">
                <MenuItem className="avenir-book" disabled value={'none'}>
                  Base Mile Group
                </MenuItem>
                <MenuItem className="avenir-book" value="Group 1">
                  Group 1
                </MenuItem>
                <MenuItem className="avenir-book" value="Group 2">
                  Group 2
                </MenuItem>
                <MenuItem className="avenir-book" value="Group 3">
                  Group 3
                </MenuItem>
              </TextField>
            }
          />
        </div>

        <div className="margin-top-basic textcenter margin-bottom-basic">
          <Controller
            rules={{ validate: field => field && field != 'none' }}
            name="type"
            defaultValue={'none'}
            control={control}
            error={!!errors.type}
            helperText={!!errors.type && 'Type is required'}
            as={
              <TextField InputLabelProps={{ className: 'avenir-book' }} fullWidth select variant="outlined">
                <MenuItem className="avenir-book" disabled value={'none'}>
                  Type
                </MenuItem>
                <MenuItem className="avenir-book" value="Sport">
                  Sport
                </MenuItem>
                <MenuItem className="avenir-book" value="NonSport">
                  Non Sport
                </MenuItem>
                <MenuItem className="avenir-book" value="atv">
                  ATV
                </MenuItem>
                <MenuItem className="avenir-book" value="snw">
                  SNW
                </MenuItem>
              </TextField>
            }
          />
        </div>

        <NewFillButton onClick={Confirm}>OK</NewFillButton>
        <div onClick={handleClose} className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
